import React, { useState, useEffect } from "react";

//Import Table and css for table
import BootstrapTable from "react-bootstrap-table-next";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
const { SearchBar } = Search;

// import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
// import moment from "moment/min/moment-with-locales";

import moment from "moment";
import "moment/locale/th";

moment.locale("th");

//Import service
import TimeregService from "../../services/timereg.service";
import authService from "../../services/auth.service";

//Import ConfirmAlert
import { confirmAlert } from "react-confirm-alert";

import Modaladdtimereg from "./Modaladdtimereg";
import Modaledittimereg from "./Modaledittimereg";

function Timereglist() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [show_add, setShow_add] = useState(false);
  const [show_edit, setShow_edit] = useState(false);
  const [timereg_id, setTimereg_id] = useState(0);

  const user = authService.getCurrentUser();

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    TimeregService.getTimereglist(user.user.user_reg)
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => {
        console.error("error fetching data: ", error);
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const clickDelete = (row) => {
    confirmAlert({
      title: "",
      message: "ต้องการลบใช่หรือไม่",
      buttons: [
        {
          label: "ใช่",
          onClick: () => {
            TimeregService.deleteTimereg(row.timereg_id)
              .then((response) => {
                if (response.data.success) {
                  // setShow_delete(false);
                  // alert(response.data.message);

                  setData((a) => {
                    return a.filter((a) => a.timereg_id != row.timereg_id);
                  });
                } else {
                  alert(response.data.message);
                }
              })
              .catch((error) => {
                console.error("error delete", error);
              });
          },
        },
        {
          label: "ไม่ใช่",
          onClick: () => false,
        },
      ],
      overlayClassName: "confirm-alert-custom",
    });
  };
  const clickEdit = (row) => {
    setShow_edit(true);
    setTimereg_id(row.timereg_id);
  };
  const ActionsEdit = (row) => {
    return (
      <>
        <i
          className="bi bi-pencil custom-icon-table"
          onClick={() => clickEdit(row.row)}
        ></i>
        <i
          className="bi bi-trash custom-icon-table"
          style={{ color: "red" }}
          onClick={() => clickDelete(row.row)}
        ></i>
      </>
    );
  };

  const actionsEdittFormatter = (cell, row) => {
    return <ActionsEdit row={row} />;
  };

  const columns = [
    {
      text: "timereg_id",
      dataField: "timereg_id",
      sort: true,
      // filter: textFilter({ placeholder: "ค้นหา" }),
      hidden: true,
    },
    {
      text: "รอบจดทะเบียน",
      dataField: "timereg_desc",
      sort: true,
      // editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "30%" };
      },
      style: {
        wordBreak: "break-word",
      },
      // filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "วันที่เริ่มต้น",
      dataField: "timereg_start",
      sort: true,
      editable: false,
      formatter: (cell, row) => {
        console.log(row);
        if (cell != "-") {
          return moment(cell).add(543, "year").locale("th").format("ll");
        } else {
          return cell;
        }
      },
      filterValue: (cell, row) => {
        console.log(row);
        if (cell != "-") {
          return moment(cell).add(543, "year").locale("th").format("ll");
        } else {
          return cell;
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "20%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
      // filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "วันที่สิ้นสุด",
      dataField: "timereg_stop",
      sort: true,
      editable: false,
      formatter: (cell, row) => {
        console.log(row);
        if (cell != "-") {
          return moment(cell).add(543, "year").locale("th").format("ll");
        } else {
          return cell;
        }
      },
      filterValue: (cell, row) => {
        console.log(row);
        if (cell != "-") {
          return moment(cell).add(543, "year").locale("th").format("ll");
        } else {
          return cell;
        }
      },
      headerStyle: () => {
        return { textAlign: "center", width: "20%" };
      },
      style: {
        wordBreak: "break-word",
        textAlign: "center",
      },
      // filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "ชื่อ",
      dataField: "user_name",
      sort: true,
      // editable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "20%" };
      },
      style: {
        wordBreak: "break-word",
      },
      // style: {
      //   wordBreak: "break-word",
      // },
      // filter: textFilter({ placeholder: "ค้นหา" }),
    },
    {
      text: "นามสกุล",
      dataField: "user_lastname",
      sort: true,
      // filter: textFilter({ placeholder: "ค้นหา" }),
      // searchable: false,
      headerStyle: () => {
        return { textAlign: "center", width: "20%" };
      },
      style: {
        wordBreak: "break-word",
      },
    },
    {
      text: "แก้ไข",
      dataField: "edit",
      isDummyField: true,
      // editable: false,
      formatter: actionsEdittFormatter,
      headerStyle: () => {
        return { textAlign: "center", width: "15%" };
      },
      style: {
        // wordBreak: "break-word",
        textAlign: "left",
      },
    },
  ];

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    firstPageText: "|<",
    lastPageText: ">|",
    nextPageText: ">>",
    prePageText: "<<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
    onSizePerPageChange: (page, sizePerPage) => {
      console.log("page", page);
      console.log("sizePage", sizePerPage);
    },
  });

  const handleClickAdd = () => {
    setShow_add(true);
  };

  if (loading) return <div id="search-results">Loading....</div>;
  if (error) return `Error :${error}`;

  return (
    <div>
      <Modaladdtimereg
        show={show_add}
        hidden={(a) => setShow_add(a)}
        data={data}
        setdata={(a) => setData(a)}
      />
      <Modaledittimereg
        id={timereg_id}
        setid={(a) => setTimereg_id(a)}
        show={show_edit}
        hidden={(a) => setShow_edit(a)}
        data={data}
        setdata={(a) => setData(a)}
      />
      <ToolkitProvider
        bootstrap4
        keyField="timereg_id"
        data={data}
        columns={columns}
        search
      >
        {(prop) => (
          <React.Fragment>
            <div>
              <div className="text-left">
                <button
                  className="btn btn-primary"
                  onClick={handleClickAdd}
                  style={{ padding: ".375rem .75rem", fontSize: "1rem" }}
                >
                  เพิ่มรอบการจดทะเบียน
                </button>
                <SearchBar {...prop.searchProps} />
              </div>
            </div>
            <hr />
            <BootstrapTable pagination={pagination} {...prop.baseProps} />
          </React.Fragment>
        )}
      </ToolkitProvider>
    </div>
  );
}

export default Timereglist;
